export default __webpack_public_path__ + "static/media/Terms-&-Condition.e7209f60.jpg";